import React from 'react';
import { Link } from 'react-router-dom';

const ViewTrashButton = ({ widgets }) => {
  const context = GlobalContainer.product() === 'recruiting' ? 'recruiter' : GlobalContainer.product();
  const scope = widgets.tables[0]?.scope;
  const isTrashable = ['documents', 'videos'].includes(scope);

  if (!isTrashable) return null;

  return (
    <Link to={`/${context}/${scope}/trash`} className="btn btn-secondary">
      View Trash
    </Link>
  );
};

export default ViewTrashButton;
